import { isEmpty } from "lodash-es";

export const beaconReg = /^([a-fA-F0-9]{8})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{4})[-]([a-fA-F0-9]{12})$/;
export const beaconMask = '********-****-****-****-************'
export const isBeacon = (val) => {
  // return beaconReg.test(hex);
  return isEmpty(val) || restoreBeacon(val).length === 32
};
export const transformBeacon = (val) => {
  if (!val) return val
  const _val = restoreBeacon(val).slice(0, 32)
  return _val.replace(/([a-fA-F0-9]{8})([a-fA-F0-9]{4})?([a-fA-F0-9]{4})?([a-fA-F0-9]{4})?([a-fA-F0-9]+)$/, "$1-$2-$3-$4-$5").replace("----", "-").replace("---", "-").replace("--", "-")
}

export const restoreBeacon = (val) => {
  if (!val) return val
  return val.replace(/[^a-fA-F0-9]/g, "").replace(/[-]/g, "")
}